import { Injectable } from '@angular/core';

import { BehaviorSubject, debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import { MdbModalRef, MdbModalService } from 'src/lib/mdb5-adapted/public-api';

import { SpinnerComponent } from './spinner.component';

@Injectable({ providedIn: 'root' })
export class LoadSpinnerService {
  private spinDialogRef: MdbModalRef<SpinnerComponent> | null = null;

  private _loadingrx = new BehaviorSubject<boolean>(false);
  public readonly loadingrx$ = this._loadingrx.asObservable();
  private _loadingSubject = new BehaviorSubject<boolean>(false);
   // Exposed observable with debounce to prevent flicker
  public readonly loading$: Observable<boolean>;

  private _debouncedLoading$: Observable<boolean>;

  private _message = new BehaviorSubject<string>('');
  public readonly message$ = this._message.asObservable();

  private _showspinner = new BehaviorSubject<number>(1);
  public readonly showspinner$ = this._showspinner.asObservable();

  constructor(public modalService: MdbModalService) {
    this._debouncedLoading$ = this._loadingSubject.asObservable().pipe(
      debounceTime(200), // Adjust delay to taste (300ms is a good starting point)
      distinctUntilChanged()
    );

    this.loading$ = this._loadingSubject.asObservable();//or this._debouncedLoading$;
  }

  startLoading(message?: string, withTimer: number = 1): MdbModalRef<SpinnerComponent> | null {
    if (this.spinDialogRef) {
      // already open; update message and timer only
      this._message.next(message || 'new message!!');
      this._showspinner.next(withTimer);
      return this.spinDialogRef;
    }

    this._loadingSubject.next(true);
    this._message.next(message || "Please wait!");
    this._showspinner.next(withTimer);

    this.spinDialogRef= this.createSpinnerModal((!message || message == '') ? "Please wait!" : message, withTimer);
    return this.spinDialogRef;
  }

  private createSpinnerModal(message: string, withTimer: number): MdbModalRef<SpinnerComponent> {
    return this.modalService.open(SpinnerComponent, {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      modalClass: 'modal-sm modal-fluid modal-dialog-centered modal-center modal-notify modal-info lms-spinner-modal',
      data: {
        message,
        showTimer: withTimer
      }
    });
  }

  stopLoading(ref?: MdbModalRef<SpinnerComponent> | null) {
    this._loadingSubject.next(false);
    if (ref) {
      ref.close();
    } else if (this.spinDialogRef) {
      this.spinDialogRef.close();
      this.spinDialogRef = null;
    }
  }

  showrx() {
    this._loadingrx.next(true);
  }

  hiderx() {
    this._loadingrx.next(false);
  }

  public show() {
    this.startLoading();
  }

  public hide() {
    this.stopLoading();
  }
}
